import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { CloseIcon } from 'components';
import { getActivityPostByid } from 'redux/features/ActivityPostSlice';
import {
  PostArrowBack,
  PostBox,
  PosthistoryStyle,
  UserDetails,
  UserProfile,
  UserInfo,
  PostMessageStyle,
} from './Home.style';
import { ReactComponent as ProfilePic } from 'assert/images/Common/profileImg.svg';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

export default function Posthistory() {
  const { singlePost } = useSelector((state) => state.PostActivitySlice);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { postId } = useParams();
  const { t } = useTranslation();

  const [PostHistoryData, setPostHistoryData] = useState([]);

  useEffect(() => {
    dispatch(getActivityPostByid(postId));
  }, []);

  useEffect(() => {
    const posthistory = [singlePost?.data?.postDetails];
    singlePost?.data?.editData?.map((data) => posthistory.push(data));
    setPostHistoryData(posthistory);
  }, [singlePost]);

  return (
    <>
      <Helmet>
        <title>Post History | WafyNet - View Edit History</title>
        <meta
          name="description"
          content="See the edit history and previous versions of user posts on WafyNet. Track changes made to shared posts."
        />
      </Helmet>
      <PosthistoryStyle>
        <PostArrowBack className="post-back">
          <CloseIcon iconType={'back'} onClick={() => navigate('/')} />
          <div>{t('HomePage.PostHistory')}</div>
        </PostArrowBack>
        <PostMessageStyle>
          {PostHistoryData?.map((data, index) => (
            <>
              {index === 1 && <div className='post-history-title'>{t('HomePage.History')}</div>}
              <PostBox key={index}>
                <div className="edited-text">
                  {index === 0 && <div>{t('HomePage.OriginalPost')}</div>}
                  <span>{index === 0 ? t('HomePage.Posted') : t('HomePage.Edited')} on{' '}
                    {index === 0 ? moment(data?.updated_At).format('hh:mm A . MMM DD,YYYY') : moment.utc(data?.post_createdAt).format('hh:mm A . MMM DD,YYYY')}</span>
                </div>
                <UserInfo className="post-history-profile">
                  <div className="about-info">
                    <UserProfile>
                      {PostHistoryData?.[0]?.profileImage ? (
                        <img
                          src={PostHistoryData?.[0]?.profileImage}
                          className="profile-img"
                          alt="profile-picture"
                        />
                      ) : (
                        <ProfilePic />
                      )}
                    </UserProfile>
                    <UserDetails>
                      <div className="display-name">
                        {PostHistoryData?.[0]?.displayName}
                      </div>
                      <div className="user-name">
                        {'@' + PostHistoryData?.[0]?.username}
                      </div>
                    </UserDetails>
                  </div>
                </UserInfo>
                <div
                  className={`description-section`}
                  dangerouslySetInnerHTML={{
                    __html: data?.description,
                  }}
                />
              </PostBox>
            </>
          ))}
        </PostMessageStyle>
      </PosthistoryStyle>
    </>
  );
}
